import { NPS_LOOKER_DATA_URL } from 'components/NpsTransitionModal/constants'
import Spinner from 'components/Spinner'
import useCurrentMerchant from 'hooks/useCurrentMerchant'
import { useSelector } from 'react-redux'
import { Redirect } from 'react-router-dom'
import { selectCurrentMerchantUser } from 'selectors/merchantUser'
import { useAbility } from 'utilities/ability'

// The legacy NPS "Respond" page has been fully retired: every viewer is
// handed over to the InsightsLab NPS labs instead.
const RouteWrapper = () => {
  const ability = useAbility()
  const merchant = useCurrentMerchant()
  const merchantUser = useSelector(selectCurrentMerchantUser)

  // The ability is rebuilt as the merchant / merchant-user payloads settle, and
  // unlike ProtectedPageHeader's re-rendered forbidden panel a Redirect is
  // destructive — deciding before they land bounces EVERY viewer to "/" on a
  // cold load or refresh. Same guard, for the same reason, as ProtectedRoute's.
  if (!merchant || !merchantUser) {
    return (
      <Spinner isLoading size="4x" className="text-center margin-top-huge" />
    )
  }

  // Same subject/action the scene's own ProtectedPageHeader gates on, so a
  // viewer who cannot see feedback is bounced rather than handed the labs.
  if (ability.cannot('access', 'Feedback')) return <Redirect to="/" />

  return <Redirect to={NPS_LOOKER_DATA_URL} />
}

export default RouteWrapper
